<template>
  <section v-if="true" class="menuSettings">
    <CRenderFunction flat :contentToRender="navItems" class="py-5" />
  </section>
</template>

<script>
import { PLAN_TYPES } from '../views/plansSubscriptions/constants'
import navItems from './_navItems'

// Função recursiva para remover opções dos menos que não devem ser exibidas
const checkList = (list, ...checkableLists) => {
  list.forEach((element) => {
    if (checkElement(element.id, ...checkableLists)) element.class = 'd-none'

    if (Array.isArray(element.items)) checkList(element.items, ...checkableLists)
  })
}

// Verifica se o elementoId está em uma das listas de exclusões de opções
const checkElement = (elementId, ...checkableLists) => {
  for (let i = 0; i < checkableLists.length; i++) {
    if (checkableLists[i].indexOf(elementId) >= 0) {
      return true
    }
  }
  return false
}

export default {
  name: 'TheAside',
  extends: navItems,
  data() {
    return {
      showSideBar: true,
    }
  },

  computed: {
    show() {
      return true
    },

    minimize() {
      return this.$store.state.sidebarMinimize
    },

    isPlanCorporate() {
      return this.$store.state.auth.session.organization.planType == PLAN_TYPES.CORPORATE
    },
  },

  created() {
    this.openMenubyRoute()
  },

  methods: {
    openMenubyRoute() {
      // ? Verifica o objeto que deve ser usado com base se há o organizatinoId nas rotas
      if (this.$route.params.organizationId) {
        this.navItems[0]._children.forEach((element) => {
          element.show = element.id?.toUpperCase() === this.$route.meta.menuType.toUpperCase()
        })
      } else {
        this.navItems[0]._children.forEach((element) => {
          element.show = element.id?.toUpperCase() === this.$route.meta.menuType.toUpperCase()
          if (element.dataOrg == 'need') {
            element._class = 'd-none'
          }
        })
      }

      this.hideMenuOptions()
    },

    hideMenuOptions() {
      let checkableLists = []
      let nonCorporate = ['subOrganization', 'Whitelabel']
      let nonSenditUser = ['Whitelabel']

      if (!this.isPlanCorporate) checkableLists.push(nonCorporate)
      if (!this.$store.getters['auth/isSendit']) checkableLists.push(nonSenditUser)

      // checkList(this.navItems[0]._children, ...checkableLists)

      // if (!this.isPlanCorporate) {
      //   this.navItems[0]._children.forEach((element) => {
      //     if (!checkElement(element.id, nonCorporate, nonSenditUser)) {
      //       element.class = 'd-none'
      //     }

      //     if (Array.isArray(element.items)) {
      //       element.items.forEach((elm) => {})
      //     }

      //     // if (element.id == 'Organization & Users') {
      //     //   element.items.forEach((el) => {
      //     //     if (el.item == 'subOrganization') {
      //     //       el.class = 'd-none'
      //     //     }
      //     //   })
      //     // }
      //     // if (element.id == 'Whitelabel') {
      //     //   element._class = 'd-none'
      //     // }
      //   })
      // }
    },
  },
}
</script>

<style lang="scss">
.menuSettings {
  background: var(--white);
  .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link {
    color: var(--gray-800);
  }

  .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link.c-active,
  .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-dropdown-toggle {
    color: var(--gray-800);
  }

  .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link:hover,
  .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-dropdown-toggle:hover {
    background: var(--gray-200) !important;
  }

  .c-sidebar-nav-dropdown-items > .c-sidebar-nav-item {
  }

  .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link.c-active {
    background: var(--gray-200) !important;
  }

  .c-sidebar-nav-icon {
    margin-right: 15px;
  }

  .c-sidebar-nav-dropdown {
    transition: 0.3s;
    &.c-show {
      background: transparent;
    }

    .c-sidebar-nav-dropdown-items {
      .c-sidebar-nav-link {
        color: var(--gray-800);
        padding-left: 120px;
      }
    }
  }

  .c-sidebar-nav-item {
    .c-sidebar-nav-link {
      color: var(--gray-800);
      padding-left: 100px;
    }
  }

  .c-sidebar-nav-item .c-sidebar-nav-link.c-active {
    color: var(--gray-800);
    background: var(--gray-200) !important;
  }

  .c-sidebar-nav-dropdown-toggle {
    padding-left: 100px;
    &::after {
      width: 15px;
      height: 15px;
      flex: 0 14px;
      background: url(/img/icons/arrowDown.svg) no-repeat center;
    }

    &.c-sidebar-nav-icon {
      margin-left: 1rem;
    }
  }

  .c-sidebar-nav-link:hover.c-sidebar-nav-dropdown-toggle::after {
    width: 15px;
    height: 15px;
    flex: 0 14px;
    background: url(/img/icons/arrowDown.svg) no-repeat center;
    background: url(/img/icons/arrowDown.svg) no-repeat center;
  }

  .c-sidebar-nav-title {
    margin-top: 0;
    font-size: 1.7rem;
    text-transform: capitalize;
    font-weight: normal;
    padding-left: 85px;
  }

  .c-sidebar-nav > .c-sidebar-nav-item {
    // padding-left: 1.5rem;
    text-transform: capitalize;
  }

  .c-sidebar-minimizer:hover::before {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%23a1a8b3' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E");
  }
}
</style>
